import { render, staticRenderFns } from "./UserStatTable.vue?vue&type=template&id=60f74e8f&scoped=true&"
import script from "./UserStatTable.vue?vue&type=script&lang=js&"
export * from "./UserStatTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f74e8f",
  null
  
)

export default component.exports